// All palette definitions are sourced from: https://www.figma.com/design/nEZEXNaJFQP3x5pD7MqV80/Smoothie-WIP?node-id=318-14709&node-type=vector&m=dev
export {
    accent,
    accentAlpha,
    accentDark,
    accentDarkAlpha,
} from './palettes/accent';
export {
    dropletBlue,
    dropletBlueAlpha,
    dropletBlueDark,
    dropletBlueDarkAlpha,
} from './palettes/dropletBlue';
export { gray, grayAlpha, grayDark, grayDarkAlpha } from './palettes/gray';
export { green, greenAlpha, greenDark, greenDarkAlpha } from './palettes/green';
export { leaf } from './palettes/leaf';
export { lemon } from './palettes/lemon';
export {
    marigold,
    marigoldAlpha,
    marigoldDark,
    marigoldDarkAlpha,
} from './palettes/marigold';
export {
    orange,
    orangeAlpha,
    orangeDark,
    orangeDarkAlpha,
} from './palettes/orange';
export {
    orchidPink,
    orchidPinkAlpha,
    orchidPinkDark,
    orchidPinkDarkAlpha,
} from './palettes/orchidPink';
export { peach, peachAlpha, peachDark, peachDarkAlpha } from './palettes/peach';
export { petal } from './palettes/petal';
export { fruitfulGreen } from './palettes/primary';
export { red, redAlpha, redDark, redDarkAlpha } from './palettes/red';
export {
    sweetViolet,
    sweetVioletAlpha,
    sweetVioletDark,
    sweetVioletDarkAlpha,
} from './palettes/sweetViolet';
export {
    tomatoRed,
    tomatoRedAlpha,
    tomatoRedDark,
    tomatoRedDarkAlpha,
} from './palettes/tomatoRed';
export {
    wasabi,
    wasabiAlpha,
    wasabiDark,
    wasabiDarkAlpha,
} from './palettes/wasabi';
export { water } from './palettes/water';
